/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Directive, ElementRef, HostListener} from '@angular/core';

import {Dropdown} from './dropdown';
import {RootDropdownService} from './providers/dropdown.service';
export class DropdownItem {
/**
 * @param {?} dropdown
 * @param {?} el
 * @param {?} _dropdownService
 */
constructor(private dropdown: Dropdown,
private el: ElementRef,
private _dropdownService: RootDropdownService) {}
/**
 * @return {?}
 */
onDropdownItemClick(): void {
        if (this.dropdown.isMenuClosable && !this.el.nativeElement.classList.contains("disabled")) {
            this._dropdownService.closeMenus();
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "[clrDropdownItem]", host: {"[class.dropdown-item]": "true"}}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Dropdown, },
{type: ElementRef, },
{type: RootDropdownService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'onDropdownItemClick': [{ type: HostListener, args: ["click", ] },],
};
}

function DropdownItem_tsickle_Closure_declarations() {
/** @type {?} */
DropdownItem.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DropdownItem.ctorParameters;
/** @type {?} */
DropdownItem.propDecorators;
/** @type {?} */
DropdownItem.prototype.dropdown;
/** @type {?} */
DropdownItem.prototype.el;
/** @type {?} */
DropdownItem.prototype._dropdownService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
